import { cva } from 'class-variance-authority'

export const tooltipStyles = cva(
  [
    'py-2 px-3',
    'w-max max-w-[calc(100vw-20px)] sm:max-w-md rounded-base',
    'text-center text-xs font-normal',
    'shadow-popover',
  ],
  {
    variants: {
      inverted: {
        true: 'bg-surface-inverse text-content-on-inverse',
        false: 'bg-surface text-content',
      },
      // Non-interactive tooltips ignore the pointer so they never intercept
      // hover/click. Interactive tooltips must be hoverable/clickable so the
      // panel can hold links and stay open while the pointer is over it.
      interactive: {
        true: 'pointer-events-auto',
        false: 'pointer-events-none',
      },
    },
    defaultVariants: {
      inverted: true,
      interactive: false,
    },
  },
)
